import * as React from "react";
import { connect } from "react-redux";
import { AppState } from "../../../redux";
import $ from "jquery";
import { Person } from "@radivision/graphql/lib/ts/graphql/person";
import { Entity } from "@radivision/graphql/lib/ts/graphql/entity";

import "./partners.scss";
import { Navbar } from "../../../react-components/page-framework/nav-bar";
import { Footer } from "../../../react-components/page-framework/footer";
import { PartnersLogos } from "./logos";

interface ComponentProps {
  subject: Person | Entity;
}

interface MapDispatchProps {}

interface MapStateProps {
  user: Person | null;
}

export type Props = ComponentProps & MapDispatchProps & MapStateProps;

export const PartnersListComponent = () => {
  React.useEffect(() => {
    $("body").addClass("allow-scroll");
  });
  return (
    <Container>
      <PartnersLogos />
    </Container>
  );
};

const Container = ({ children }: React.PropsWithChildren<any>) => (
  <div className="partners-list">
    <div className="partners-container">{children}</div>
  </div>
);

const mapState = (state: AppState) => ({
  user: state.account.user,
});

const mapDispatch = {};

export const PartnersList = connect(mapState, mapDispatch)(PartnersListComponent);
